import { isAxiosError, type RawAxiosRequestConfig } from 'axios';

export type ApiRequestOptions = RawAxiosRequestConfig & { voxErrorDisplay?: 'inline' };

export const INLINE_API_ERROR_OPTIONS: ApiRequestOptions = { voxErrorDisplay: 'inline' };

/** Определяет запрос с ошибкой внутри открытого экрана */
export const hasInlineErrorDisplay = (error: unknown): boolean => (
    isAxiosError(error) && Boolean(error.config && 'voxErrorDisplay' in error.config && error.config.voxErrorDisplay === 'inline')
);

/** Сохраняет причину недоступности фоновых данных */
export class InlineApiError extends Error {
    readonly status: number | undefined;

    constructor(message: string, status: number | undefined) {
        super(message);
        this.status = status;
    }
}
